<template>
  <v-layout align-center @click="$emit('click')">
    <!-- The seller of the category -->
    <v-flex shrink class="grey--text font-weight-light">{{ category.sellerName }}</v-flex>
    <!-- The name of the category -->
    <v-flex class="text-xs-left">
      <span class="font-italic grey--text pl-2">{{ category.name }}</span>
    </v-flex>
    <!-- The stats of the group -->
    <v-flex>
      <v-layout align-center justify-end>
        <v-flex v-for="(stat, index) in stats" :key="index" shrink>
          <v-chip>
            <span class="font-weight-light pr-1">{{stat.name}}:</span>
            <span>{{stat.value}}</span>
          </v-chip>
        </v-flex>
        <!-- The button to open the category url -->
        <v-flex shrink>
          <v-btn icon @click.stop="openUrl" :disabled="!category.url">
            <v-icon color="blue-grey">open_in_new</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      required: true,
      validator: val => !!val.name && !!val.sellerId
    }
  },
  computed: {
    /**
     * Generate the stats object to iterate over them and write them using a chip.
     * The stats are the max, mean and min probabilities of the group.
     */
    stats() {
      const { avg, max, min } = this.category.probability;
      return [
        {
          name: "Items",
          value: this.category.itemsCount
        },
        {
          name: "Promedio",
          value: this.formatProbability(avg)
        },
        {
          name: "Max",
          value: this.formatProbability(max)
        },
        {
          name: "Mín",
          value: this.formatProbability(min)
        }
      ];
    }
  },
  methods: {
    /**
     * Amplifiy the probability by 100 (to have values between 0 and 1) and fix the number of decimal
     * places of it.
     */
    formatProbability(prob) {
      return (prob * 100).toFixed(2);
    },
    /**
     * Open the URL of the category in a new tab.
     */
    openUrl() {
      window.open(this.category.url, "_blank");
    }
  }
};
</script>